export function parseTopic(topicKor?: string | null) {
  return topicKor
    ? topicKor
        .split(", ")
        .filter((topic) => topic && topic.length < 10)
        .splice(0, 3)
    : [];
}
